export default __webpack_public_path__ + "static/media/procura-vaga.92da45ef.jpg";